export enum PackageId {
    SmoovedPlus = 'smooved-plus',
    SmoovedLive = 'smooved-live',
    Smooved2020 = 'smooved-2020',
    HouseMatchVerified = 'housematch-verified',
}
